import { render, staticRenderFns } from "./Videotutorials.vue?vue&type=template&id=7453abb2"
import script from "./Videotutorials.vue?vue&type=script&lang=js"
export * from "./Videotutorials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports